module.exports = __webpack_public_path__ + "static/img/login_logo_new.f7a1a283.png";